/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentCategoriesAutomaticCreationPanelComponent(this: JS5Object, _: JS5Object) {


    this.$onInit = () => {
        _.set(this, 'editData.contentCategoryObject.daysOfWeekSchedule', _.get(this, 'editData.contentCategoryObject.daysOfWeekSchedule', []))
    };

    this.$onChanges = () => {
        _.set(this, 'editData.contentCategoryObject.daysOfWeekSchedule', _.get(this, 'editData.contentCategoryObject.daysOfWeekSchedule', []))
    };
}

angular.module('prism-ui.content').component('contentCategoriesAutomaticCreationPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/automaticCreationPanel/content-categories-automatic-creation-panel-template.html',
    controller: ContentCategoriesAutomaticCreationPanelComponent,
    bindings: {
        editData: '<'
    }
});
